/*
 * @Author: g05047
 * @Date: 2021-03-09 11:29:55
 * @LastEditors: g05047
 * @LastEditTime: 2021-03-12 16:26:46
 * @Description: file content
 */
import fvSubassembly from '../fvSubassembly';
export default class fvRect extends fvSubassembly {
    constructor(sContent, parent, system, callback) {
        super(sContent, parent, system);
        this.create();
        if (this.isDelayedWaiting) {
            this.complete = callback;
        } else {
            callback(this);
        }
        //创建图元
        //添加折线
        this.rectDom = document.createElementNS('http://www.w3.org/2000/svg', 'rect')
        system.appendChild(this.rectDom);
        if (this.renderType == 4 || this.renderType == 5 || this.renderType == 6) {
            this.rectDefs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
            system.insertBefore(this.rectDefs, this.rectDom);
        } else if (this.renderType == 1) {
            this.refLineDom = document.createElementNS('http://www.w3.org/2000/svg', 'g');
            system.appendChild(this.refLineDom);
        }
        this.createSucss(this.rectDom, sContent);
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.lineRectDom = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                system.appendChild(this.lineRectDom);
            }
        }
        //创建样式
        this.parent = parent;
        this.createStyle();
        this.system = system;
        this.regionHeight = this.height - this.borderWidth;
        this.regionWidth = this.width - this.borderWidth;
    }
    createStyle() {
        this.setPosition();
        this.rectDom.style.strokeWidth = this.borderWidth
        this.setBorderColor();
        //线型
        super.chooseRenderType(this.lineType, this.rectDom)
        this.isRound()
        this.setFillColor();
        this.Render();
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.lineRectDom.innerHTML = "";
                this.drawStereo(this.lineRectDom, this.rectDom);
            }
        }
        // this.monitorFun();//监听私有
        //风格，移动等预制动画
        // console.log(this.renderType)
    }
    setPosition() {
        this.rectDom.setAttribute('x', this.cx - this.parent.parentX);
        this.rectDom.setAttribute('y', this.cy - this.parent.parentY);
        this.rectDom.style.width = this.width + "px";
        this.rectDom.style.height = this.height + "px";
    }
    setFillColor() {
        this.isHollow()
    }
    // 设置边框颜色
    setBorderColor() {
        this.rectDom.style.stroke = this.borderColor
    }
    // 显示隐藏
    isShow(value) {
        value ? this.rectDom.style.display = 'block' : this.rectDom.style.display = 'none';
    }
    init() {
        super.init();
        if (this.originalSize.width / (this.frameScaleX + 1) >= 2) {
            this.width -= 1;
        }
        this.moveWidth = this.borderWidth / 2;
    }
    onDraw() {
        //调用动画 完成动画 更改实时样式
        this.executePreAnimation(this.rectDom);
        this.rectDom.style.transform = `translate(${this.translateX + 'px'}, ${this.translateY + 'px'}) rotate(${this.rotating + 'deg'}`;
        this.rectDom.style.transformOrigin = `${this.originPinitX + "px"}  ${this.originPinitY + "px"}`;
    }
    //风格渲染
    Render() {
        if (this.renderConfig == undefined || JSON.stringify(this.renderConfig) == "{}") return;
        let x = this.rectDom.getAttribute("x");
        let y = this.rectDom.getAttribute("y");
        var SIN_COS_API = 3.141592625;
        var rd = this.renderConfig;
        var m_fRotate = SIN_COS_API / 180 * parseFloat(0); //跟draw的精度一样
        if (rd.color) {
            var colorNum = rd.color.length;
        }
        let pax = this.cx - this.parent.parentX;
        let pay = this.cy - this.parent.parentY;
        var rect = {
            left: pax,
            top: pay,
            bottom: parseFloat(pay + this.height - this.borderWidth),
            right: parseFloat(pax + this.width - this.borderWidth),
            width: parseFloat(this.width),
            height: parseFloat(this.height)
        }
        switch (this.renderType) {
            case 1:  //模式1
                this.refLineDom.innerHTML = "";
                this.render.rend(this.refLineDom, rect, rd.grade, "", rd.color, colorNum, rd.colorGrade, m_fRotate);
            // case 2:  //模式2
            // case 3:  //模式3
            case 4:  //svg线性渐变效果
                this.linearGradient(this.uuid(), this.renderConfig, this.rectDom, x, y, this.rectDefs);
                break;
            case 5:  //svg路径渐变效果
                this.radialGradient(this.uuid(), this.renderConfig, this.rectDom, x, y, this.rectDefs);
                break;
            case 6:  //svg纹理渐变效果

                this.pattern(this.uuid(), this.rectDom, this.rectDefs);
                break;
            default:
                break;
        }
    }
    // 是否有圆角
    isRound() {
        if (this.round) {
            this.rectDom.setAttribute('rx', this.round[0])
            this.rectDom.setAttribute('ry', this.round[1])
        } else {
            this.rectDom.removeAttribute('rx')
            this.rectDom.removeAttribute('ry')
        }
    }
    //是否是空心
    isHollow() {
        if (this.color == "" || this.opacity <= 0) {
            this.rectDom.style.fill = 'rgba(0, 0, 0, 0)';
        } else {
            let rgbArray = this.color.colorRgb(this.opacity / 255);
            this.rectDom.style.fill = rgbArray
        }
    }
    /*16进制颜色转为RGBA格式*/
    hexToRgba(hex, opacity) {
        return "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" + hex.slice(5, 7)) + "," + opacity + ")";
    }
    //监听图元属性
    monitorFun() {
        // Object.defineProperty(this,"color",{
        //     set(value){
        //         this.svgDom.style.fill = value;
        //     },
        //     get(){}
        // })
    }
    //生成path路径
    getRectPath(x, y, width, height, rx, ry) {
        /*
        * rx 和 ry 的规则是： 
        * 1. 如果其中一个设置为 0 则圆角不生效 
        * 2. 如果有一个没有设置则取值为另一个 
        */
        rx = rx || ry || 0;
        ry = ry || rx || 0;
        //非数值单位计算，如当宽度像100%则移除
        if (isNaN(x - y + width - height + rx - ry)) return;
        rx = rx > width / 2 ? width / 2 : rx; 
        ry = ry > height / 2 ? height / 2 : ry;
        //如果其中一个设置为 0 则圆角不生效
        if(0 == rx || 0 == ry){
            var path = 
            'M' + x + ' ' + y + 
            'h' + width + 
            'v' + height + 
            'h' + -width + 
            'z'; 
        }else{
            var path = 
            'M' + x + ' ' + (y+ry) + 
            'a' + rx + ' ' + ry + ' 0 0 1 ' + rx + ' ' + (-ry) + 
            'h' + (width - rx - rx) + 
            'a' + rx + ' ' + ry + ' 0 0 1 ' + rx + ' ' + ry + 
            'v' + (height - ry -ry) + 'a' + rx + ' ' + ry + ' 0 0 1 ' + (-rx) + ' ' + ry + 
            'h' + (rx + rx -width) + 'a' + rx + ' ' + ry + ' 0 0 1 ' + (-rx) + ' ' + (-ry) + 
            'z'; 
        } 
        return path;
    }
           
}



// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvRectObj.js